import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserAdjustments = ({
  userId,
  groupId,
  benefitType,
  planPeriod,
}) =>
  call(websocketFetch, 'get_user_adjustments', {
    user_id: userId,
    group_id: groupId,
    benefit_type: benefitType,
    plan_period: planPeriod,
  });
